const appConfig = {
    apiPrefix: 'https://kimera.ahlamkom.net',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig